import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const AgeVerification = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà confirmé son âge
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowModal(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowModal(false);
  };

  const handleDecline = () => {
    // Rediriger vers une page d'information ou simplement fermer
    window.location.href = 'https://www.joueurs-info-service.fr';
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-primary-red/10 p-4 rounded-full">
            <AlertTriangle className="text-primary-red" size={48} />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 text-center mb-4">
          Vérification d'âge
        </h2>

        <p className="text-lg text-gray-700 text-center mb-6 leading-relaxed">
          Vous devez avoir au moins 18 ans pour accéder à ce site. Les paris en ligne sont interdits aux mineurs.
        </p>

        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-6 rounded-r-lg">
          <p className="text-sm text-gray-700">
            <strong>Important :</strong> Le jeu peut être dangereux. Jouez de manière responsable. 
            Si vous avez un problème de jeu, consultez <a href="https://www.joueurs-info-service.fr" target="_blank" rel="noopener noreferrer" className="text-primary-red hover:underline">Joueurs Info Service</a>.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleConfirm}
            className="flex-1 bg-primary-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-red-dark transition-colors"
          >
            J'ai plus de 18 ans
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-gray-200 text-gray-800 px-6 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
          >
            J'ai moins de 18 ans
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

